<template>
  <div class="main-menu-list">
    <div v-if="!menuList.length" class="main-menu_error">
      通信エラーにより、メニューを表示できませんでした。
    </div>
    <i-menu @on-select="onSelectMenu">
      <template v-for="(item, idx) in menuList">
        <template v-if="isDisplay(item.status)">
          <template v-if="item.child">
            <i-submenu :key="`menu${idx}`" :name="`menu${idx}`" :disabled="item.status === 'disable'">
              <template slot="title">
                <div class="menu-item">
                  <div class="menu-item__icon">
                    <template v-if="item.icon">
                      <img :src="item.icon" />
                    </template>
                    <template v-else>
                      >
                    </template>
                  </div>
                  <span class="menu-item__text">{{ item.label }}</span>
                </div>
              </template>
              <template v-for="(child, childIdx) in item.child">
                <template v-if="isDisplay(child.status)">
                  <template v-if="child.child">
                    <i-submenu :key="`menuChild${childIdx}`" :name="`menuChild${childIdx}`">
                      <template slot="title">
                        <div class="menu-item">
                          <div class="menu-item__icon">
                            <template v-if="child.icon">
                              <img :src="child.icon" />
                            </template>
                            <template v-else>
                              >
                            </template>
                          </div>
                          <span class="menu-item__text">
                            {{ child.label }}
                          </span>
                        </div>
                      </template>
                      <template v-for="(gChild, gChildIdx) in child.child">
                        <template v-if="isDisplay(gChild.status)">
                          <i-menu-item
                            :key="`gChild${gChildIdx}`"
                            :name="menuUrl(gChild.url)"
                            :disabled="gChild.status === 'disable'"
                          >
                            <div class="menu-item__icon">
                              <template v-if="gChild.icon">
                                <img :src="gChild.icon" />
                              </template>
                              <template v-else>
                                >
                              </template>
                            </div>
                            <span class="menu-item__text">{{ gChild.label }}</span>
                          </i-menu-item>
                        </template>
                      </template>
                    </i-submenu>
                  </template>
                  <template v-else>
                    <i-menu-item
                      :key="`menuChild${childIdx}`"
                      :name="menuUrl(child.url)"
                      :disabled="child.status === 'disable'"
                    >
                      <div class="menu-item">
                        <div class="menu-item__icon">
                          <template v-if="child.icon">
                            <img :src="child.icon" />
                          </template>
                          <template v-else>
                            >
                          </template>
                        </div>
                        <span class="menu-item__text">
                          {{ child.label }}
                        </span>
                      </div>
                    </i-menu-item>
                  </template>
                </template>
              </template>
            </i-submenu>
          </template>
          <template v-else>
            <i-menu-item :key="`menu${idx}`" :name="menuUrl(item.url)" :disabled="item.status === 'disable'">
              <div class="menu-item">
                <div class="menu-item__icon">
                  <template v-if="item.icon">
                    <img :src="item.icon" />
                  </template>
                  <template v-else>
                    >
                  </template>
                </div>
                <span class="menu-item__text">{{ item.label }}</span>
              </div>
            </i-menu-item>
          </template>
        </template>
      </template>
    </i-menu>
    <div v-if="this.is3nosuke" class="sp-qr">
      <i-row style="margin-top: 16px;">
        <i-col>
          <!-- マニュアルリンク -->
          <i-button
            to="/assets/img/sale-manual.pdf"
            type="primary"
            size="small"
            icon="ios-download-outline"
            target="_blank"
            style=""
          >
            マニュアル
          </i-button>
        </i-col>
      </i-row>
    </div>
  </div>
</template>

<script>
import { Menu, Submenu, MenuItem, Row, Col, Button } from 'view-design'
export default {
  components: {
    'i-menu': Menu,
    'i-submenu': Submenu,
    'i-menu-item': MenuItem,
    'i-row': Row,
    'i-col': Col,
    'i-button': Button,
  },
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      is3nosuke: false,
      currentUrl: '',
    }
  },
  created() {
    this.currentUrl = location.href
    this.is3nosuke = this.currentUrl.match('fudo-3') !== null
  },
  methods: {
    // メニュー選択時の処理 リンクへ移動する
    onSelectMenu(name) {
      const domain = document.domain
      if (!name.includes(domain) || name.match(/.pdf/) || name.match(/crm/)) {
        window.open(`${name}`, '_blank')
      } else {
        window.location.href = name
      }
    },
    // メニュー表示判定
    isDisplay(status) {
      return ['enable', 'disable'].includes(status)
    },
    // メニューに設定するurl
    menuUrl(url) {
      return url ? url : ''
    },
  },
}
</script>

<style lang="scss">
.main-menu-list {
  .main-menu_error {
    padding: 8px;
    font-size: 12px;
    color: #d33;
  }
  .menu-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    &__icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 16px;
      text-align: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
    padding-left: 40px !important;
    display: flex;
    align-items: center;
  }

  .ivu-menu-vertical .ivu-menu-submenu-has-parent-submenu .ivu-menu-item {
    padding-left: 64px !important;
    display: flex;
    align-items: center;
  }

  .ivu-menu-item.ivu-menu-item-disabled,
  .ivu-menu-submenu.ivu-menu-submenu-disabled {
    color: #ccc;
    cursor: default;
    .ivu-menu-submenu-title {
      cursor: default;
      &:hover {
        color: #ccc;
      }
    }
  }

  .ivu-menu-submenu.ivu-menu-submenu-disabled {
    color: #ccc;
    cursor: default;
    .ivu-menu-submenu-title {
      cursor: default;
      &:hover {
        color: #ccc;
      }
    }
  }

  // アクティブにしない設定
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color: inherit;
    background: inherit;
  }
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    content: '';
    display: block;
    width: 2px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background: none;
  }
  .sp-qr {
    position: fixed;
    bottom: 16px;
    text-align: center;
    width: 224px;
  }
}
</style>
